import Vue from "vue";
Vue.filter("noCurrency", (value) => {
  if (!value && value !== 0) return value;
  const format = (vl) =>
    parseFloat(vl).toLocaleString("pt-BR", { minimumFractionDigits: 2 });
  return value < 0 ? `(${format(value * -1)})` : format(value);
});
